import React from "react";
import { DateRangePicker } from "materialui-daterange-picker";
import * as fns from "date-fns";
import { Backdrop, makeStyles, Modal } from "@material-ui/core";

const useStyles = makeStyles((theme: { spacing: (arg0: number) => any; breakpoints: { down: (arg0: string) => any; }; }) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        //backgroundColor: theme.palette.background.paper,
    },
    modalContent: {
        //width: "90%",
        //maxWidth: "500px",
        //backgroundColor: theme.palette.background.paper,
        overflowX: "auto",
        padding: theme.spacing(2),
        maxHeight: "90vh", // Ensure content can scroll if needed
        [theme.breakpoints.down('sm')]: {
            //maxWidth: "90%",
            padding: theme.spacing(1),
            maxHeight: "80vh", // Constrain height for mobile view
        },
    },
    datepickerContent: {
        scrollbarWidth:"thin",
        width: "100%",
        backgroundColor: "#fff",
        overflowX: "auto",
        overflowY: "hidden",
        // "-webkit-overflow-scrolling": "touch", // Smooth scrolling on mobile
        maxHeight: "100%", // Ensure height doesn't exceed modalContent
        [theme.breakpoints.down('sm')]: {
            //maxWidth: "100%",
            overflowX: "scroll",
        },
    },
}));

const MuiDateRangePicker = (props: any) => {
    const classes = useStyles();
  
    return (
            <Modal
                className={classes.modal}
                open={props.open} 
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <div className={classes.modalContent}>
                    <DateRangePicker
                        open={props.open}
                        wrapperClassName={classes.datepickerContent}
                        toggle={props.toggle}
                        closeOnClickOutside={true}
                        onChange={(range: any) => {
                            props.onDateRangeChange(range);
                            // props.toggle();
                        }}
                        initialDateRange={props.dateRange}
                    />
                </div>
            </Modal>);
};

export { MuiDateRangePicker };
// import * as React from "react";
// import {
//   DateRangePicker,
//   DateRange,
// } from "@mui/x-date-pickers-pro/DateRangePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { Modal, Backdrop, Box } from "@mui/material";

// interface MuiDateRangePickerProps {
//   open: boolean;
//   toggle: () => void;
//   onDateRangeChange: (range: DateRange<Date>) => void;
//   dateRange: DateRange<Date>;
// }

// const MuiDateRangePicker: React.FC<MuiDateRangePickerProps> = ({
//   open,
//   toggle,
//   onDateRangeChange,
//   dateRange,
// }) => {
//   return (
//     <Modal
//       open={open}
//       onClose={toggle}
//       closeAfterTransition
//       slots={{ backdrop: Backdrop }}
//       slotProps={{ backdrop: { timeout: 500 } }}
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <Box
//         sx={{
//           bgcolor: "#fff",
//           p: { xs: 1, sm: 2 },
//           maxHeight: { xs: "80vh", sm: "90vh" },
//           overflowX: "auto",
//           borderRadius: 2,
//           boxShadow: 3,
//         }}
//       >
//         <LocalizationProvider dateAdapter={AdapterDateFns}>
//           <DateRangePicker
//             calendars={2} // number of months visible
//             value={dateRange}
//             onChange={(newValue) => onDateRangeChange(newValue)}
//           />
//         </LocalizationProvider>
//       </Box>
//     </Modal>
//   );
// };

// export { MuiDateRangePicker };
